module.exports = __webpack_public_path__ + "static/media/view4.e1d55cbb.jpg";